import { get } from 'lodash'
import React from 'react'
import { Badge, BADGE_VARIANTS } from 'components/Badge'
import {
  BOOLEAN_STATUS_BADGE_VALUES,
  EXPERT_APPLICATION_STATUS_BADGE_VALUES,
  EXPERT_STATUS_BADGE_VALUES,
  EXPERT_ZOOM_STATUS_BADGE_VALUES,
  NAVIGATION_STATUS_BADGE_VALUES,
  ORDER_ITEM_STATUS_BAGDE_VALUES,
  ORDER_STATUS_BAGDE_VALUES,
  PRODUCT_STATUS_BADGE_VALUES,
  ADMIN_PURCHASE_STATUS_BADGE_VALUES,
  SESSION_CLIENT_PAYMENT_STATUS_BADGE_VALUES,
  SESSION_CLIENT_STATUS_BADGE_VALUES,
  SESSION_STATUS_BADGE_VALUES,
  CLIENT_PURCHASE_STATUS_BADGE_VALUES,
  TRADE_LICENSE_STATUS_BADGE_VALUES,
  COLLECTION_STATUS_BADGE_VALUES,
  ACCOUNT_SET_UP_STATUS_BADGE_VALUES,
  USER_REFERRAL_STATUS_BADGE_VALUES,
  INVENTORY_SYNC_LOG_BADGE_VALUES,
  INVENTORY_SYNC_LOG_ERROR_BADGE_VALUES,
  INVENTORY_SYNC_LOG_TYPE_BADGE_VALUES,
  QUOTE_STATUS_BADGE_VALUES,
  INVENTORY_SYNC_LOG_RUN_TYPE_BADGE_VALUES,
} from './mappers'
import { CLIENT_STATUS_BADGE_VALUES } from './mappers/client'
import { formatStatusText } from './utils'

export const STATUS_BADGE_TYPE = {
  CLIENT: 'CLIENT',
  BOOLEAN: 'BOOLEAN',
  EXPERT_APPLICATION: 'EXPERT_APPLICATION',
  EXPERT: 'EXPERT',
  EXPERT_SEARCHABILITY: 'EXPERT_SEARCHABILITY',
  SESSION: 'SESSION',
  SESSION_CLIENT: 'SESSION_CLIENT',
  SESSION_CLIENT_PAYMENT: 'SESSION_CLIENT_PAYMENT',
  ZOOM_ACCOUNT_TYPE: 'ZOOM_ACCOUNT_TYPE',
  IS_EMAIL_VERIFIED: 'IS_EMAIL_VERIFIED',
  ADMIN_PURCHASE: 'ADMIN_PURCHASE',
  CLIENT_PURCHASE: 'CLIENT_PURCHASE',
  PRODUCT: 'PRODUCT',
  NAVIGATION: 'NAVIGATION',
  ORDER: 'ORDER',
  ORDER_ITEM: 'ORDER_ITEM',
  TRADE_LICENSE: 'TRADE_LICENSE',
  USER_REFERRALS: 'USER_REFERRALS',
  COLLECTION: 'COLLECTION',
  ACCOUNT_SETUP: 'ACCOUNT_SETUP',
  INVENTORY_SYNC_LOG: 'INVENTORY_SYNC_LOG',
  INVENTORY_SYNC_LOG_ERRORS: 'INVENTORY_SYNC_LOG_ERRORS',
  INVENTORY_SYNC_LOG_TYPE: 'INVENTORY_SYNC_LOG_TYPE',
  INVENTORY_SYNC_LOG_RUN_TYPE: 'INVENTORY_SYNC_LOG_RUN_TYPE',
  QUOTE: 'QUOTE',
} as const

const STATUS_BADGE_CONTENT_BY_TYPE = {
  [STATUS_BADGE_TYPE.CLIENT]: CLIENT_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.BOOLEAN]: BOOLEAN_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.EXPERT_APPLICATION]:
    EXPERT_APPLICATION_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.EXPERT]: EXPERT_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.SESSION]: SESSION_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.SESSION_CLIENT]: SESSION_CLIENT_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.SESSION_CLIENT_PAYMENT]:
    SESSION_CLIENT_PAYMENT_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.EXPERT_SEARCHABILITY]: BOOLEAN_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.ZOOM_ACCOUNT_TYPE]: EXPERT_ZOOM_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.IS_EMAIL_VERIFIED]: BOOLEAN_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.ADMIN_PURCHASE]: ADMIN_PURCHASE_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.CLIENT_PURCHASE]: CLIENT_PURCHASE_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.PRODUCT]: PRODUCT_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.NAVIGATION]: NAVIGATION_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.ORDER]: ORDER_STATUS_BAGDE_VALUES,
  [STATUS_BADGE_TYPE.ORDER_ITEM]: ORDER_ITEM_STATUS_BAGDE_VALUES,
  [STATUS_BADGE_TYPE.TRADE_LICENSE]: TRADE_LICENSE_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.COLLECTION]: COLLECTION_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.ACCOUNT_SETUP]: ACCOUNT_SET_UP_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.USER_REFERRALS]: USER_REFERRAL_STATUS_BADGE_VALUES,
  [STATUS_BADGE_TYPE.INVENTORY_SYNC_LOG_ERRORS]:
    INVENTORY_SYNC_LOG_ERROR_BADGE_VALUES,
  [STATUS_BADGE_TYPE.INVENTORY_SYNC_LOG]: INVENTORY_SYNC_LOG_BADGE_VALUES,
  [STATUS_BADGE_TYPE.INVENTORY_SYNC_LOG_TYPE]:
    INVENTORY_SYNC_LOG_TYPE_BADGE_VALUES,
  [STATUS_BADGE_TYPE.INVENTORY_SYNC_LOG_RUN_TYPE]:
    INVENTORY_SYNC_LOG_RUN_TYPE_BADGE_VALUES,
  [STATUS_BADGE_TYPE.QUOTE]: QUOTE_STATUS_BADGE_VALUES,
} as const

interface StatusBadgeProps {
  status: string | boolean
  type: (typeof STATUS_BADGE_TYPE)[keyof typeof STATUS_BADGE_TYPE]
}

export const StatusBadge: React.FC<React.PWC<StatusBadgeProps>> = ({
  status,
  type,
}) => {
  const mappedResult = get(
    STATUS_BADGE_CONTENT_BY_TYPE,
    [type, typeof status === 'boolean' ? status.toString() : status],
    {
      variant: BADGE_VARIANTS.GRAY,
      text: null,
    }
  )
  const isStatusBoolean = typeof status === 'boolean'
  const booleanStatusText = status ? 'TRUE' : 'FALSE'
  return (
    <Badge variant={mappedResult.variant}>
      {mappedResult?.text ||
        (isStatusBoolean ? booleanStatusText : formatStatusText(status))}
    </Badge>
  )
}
